import { useLang } from '@/app/utils/useLang';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import EFPicture from '@elem/ui/ef-picture';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import EcoSection from 'eco-design/base/eco-section';
import { cloneDeep } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Button from '../components/button';
import styles from './index.module.scss';

const SmartProduct: React.FC = () => {
    const { t } = useLang('smart_products');
    const { locale } = useRouter();
    const items = [
        {
            img: '',
            title: 'EcoFlow DELTA Pro Ultra',
            desc: '6kWh Capacity | 7200W AC Output | 120V & 240V',
            price: '',
            discountPrice: 0,
            productId: '8006700236954',
            variantId: '44244774650010',
            label: '',
            note: '',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/44244774650010:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
            btnDisabled: false,
        },
        {
            img: '',
            title: 'EcoFlow DELTA Pro Ultra + Extra Battery + Smart Home Panel 2',
            desc: '12kWh Capacity | 7200W AC Output | 120V & 240V',
            price: '',
            discountPrice: 0,
            productId: '8006700236954',
            variantId: '52608974455155',
            label: '',
            note: '',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/52608974455155:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=52608974455155',
            btnDisabled: false,
        },
        {
            img: '',
            title: 'EcoFlow DELTA Pro Ultra X',
            desc: '12kWh Capacity | 12kW AC Output',
            price: '',
            discountPrice: 0,
            productId: '15178584981875',
            variantId: '62111365792115',
            label: '',
            note: '',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/62111365792115:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-ultra-x?_pos=2&_sid=4935d07c9&_ss=r&variant=62111365792115',
            btnDisabled: false,
        },
    ];

    const [reactiveItems, setReactiveItems] = useState(items);
    useEffect(() => {
        getItemInfo();
    }, []);

    async function getItemInfo() {
        const variantIds = items.map((item) => item.variantId);
        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            // 过滤掉接口返回的空对象，只保留有效数据
            const validData = (res.data || []).filter((item: any) => item && Object.keys(item).length > 0 && item.variantId);
            // newItems 只保留在有效数据中出现的项
            const newItems = cloneDeep(reactiveItems).filter((_item) => validData.some((item: any) => item.variantId === _item.variantId));
            newItems.forEach((newItem) => {
                const item = validData.find((item: any) => item.variantId === newItem.variantId);
                if (item) {
                    newItem.img = item.variantImg;
                    newItem.price = item.price;
                    newItem.discountPrice = item.discountPrice;
                    newItem.btnDisabled = Number(item?.inventoryQuantity || 0) <= 0 && item?.inventoryPolicy !== 'continue';
                }
            });

            setReactiveItems(newItems);
        }
    }

    console.log('test-reactiveItems----', reactiveItems);
    const itemHtml = (tag: any, item) => {
        const Tag = tag === 'div' ? 'div' : SwiperSlide;
        return (
            <Tag className="product" key={item.title}>
                <EFPicture src={item.img} />
                <div className="bottom">
                    <div className="title">{item.title}</div>
                    <div className="desc">{item.desc}</div>
                    <div className="price">
                        <span className="cur">{FormatMoneyLocal(item.price || 0, locale)}</span>
                        {item.discountPrice && <span className="source">{FormatMoneyLocal(item.discountPrice || 0, locale)}</span>}
                    </div>
                    <div className="btns">
                        <Button type="buy" disabled={item.btnDisabled} onClick={() => link(item.buyNow)}>
                            Buy now
                        </Button>
                        <Button type="more" onClick={() => link(item.learnMore)}>
                            Learn More
                        </Button>
                    </div>
                </div>
            </Tag>
        );
    };

    function link(url: string) {
        window.open(url, '_blank');
    }

    return (
        <div className={styles.SmartProduct}>
            <EcoSection title={t('title')} desc={t('desc')} />

            <div className="products pc">
                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={0}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                >
                    {reactiveItems.map((item) => {
                        return itemHtml('SwiperSlide', item);
                    })}
                </Swiper>
            </div>
            <div className="products h5">
                {reactiveItems.map((item) => {
                    return itemHtml('div', item);
                })}
            </div>
        </div>
    );
};

export default SmartProduct;
